import React from "react";
import './about.css'
import logo from './media/codebird_logo.png'

const About = () => {
    return (
        <div className="about">
            <div className="abt">
                <p className="abt_title">
                    ABOUT EVENT
                </p>
                <p className="abt_content">
                    Unleash your creativity and join <b className="bold">H A C K &nbsp; W I Z &nbsp; 1.0</b>, an official CODEBIRD Event and the ultimate hackathon extravaganza to celebrate 7 successful years of our coding journey! Compete across diverse categories, showcasing your skills, ingenuity, and collaborative spirit alongside like-minded individuals. Discover the perfect platform to challenge yourself, acquire new skills, and craft awe-inspiring products with the potential to make a significant impact. Don't miss this unparalleled opportunity to showcase your talent and be part of the tech revolution. Welcome to <b className="bold">H A C K &nbsp; W I Z &nbsp; 1.0</b>- where innovation knows no boundaries.
                </p>
            </div>
            <div className="abt_img">
                <img src={logo} alt="Logo" />
            </div>
        </div>
    );
}

export default About;